import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { user as gaUser } from '../../services/ga'
import getScript from '../../lib/getScript'

import { signin } from '../../api'

import Logo from '../Common/Logo'
import { H2, Button } from '../Common'

import Preload from '../Pages/LoginPreload'
import Form from './Form'

import style from './Login.scss'

import man from '../../images/man.jpg'

const Man = styled.div`
  background-image: url(${man});
`

class Login extends Component {
  static propTypes = {
    search: PropTypes.object.isRequired,
    data: PropTypes.object,
  }

  static defaultProps = {
    data: {
      assets: [],
    },
  }

  state = {
    loading: false,
    logged: false,
    error: false,
    url: undefined,
    user: undefined,
    assetsPreload: false,
  }

  componentDidMount() {
    const { data } = this.props

    const callback = () => {
      this.setState((state) => ({
        ...state,
        assetsPreload: true,
      }))
    }

    Promise.all((data.assets || []).map((asset) => getScript(asset))).then(callback, callback)
  }

  onSubmit = ({ email, password, rememberMe, recaptchaResponse }, callback) => {
    this.setState(
      (state) => ({
        ...state,
        loading: true,
      }),
      () => {
        signin({ email, password, rememberMe, recaptchaResponse }).then(
          ({ data }) => {
            const { url, user } = data
            this.setState((state) => ({
              ...state,
              url,
              user,
              logged: true,
            }))
            gaUser(user.id)
            callback(undefined)
          },
          (err) => {
            this.setState((state) => ({
              ...state,
              logged: false,
              loading: false,
              error: true,
            }))
            callback(err)
          },
        )
      },
    )
  }

  render() {
    const { search } = this.props
    const { recaptchakey } = this.props.data;
    if (this.state.logged) {
      const { url, user, assetsPreload } = this.state
      return (
        <div className={style.login}>
          <Logo className={style.logo} />
          <Preload user={user} url={url} preload={assetsPreload} />
        </div>
      )
    }

    return (
      <div className={style.login}>
        <Logo className={style.logo} />
        <div className={style.container}>
          <H2>acesse sua conta</H2>
          <Form search={search} recaptchakey={recaptchakey} loading={this.state.loading} onSubmit={this.onSubmit} />
        </div>
        <div className={style.signup}>
          <H2 className={style.h2}>
            Diga oi para um <span>relacionamento fácil</span> com o cliente
          </H2>
          <p>
            Monitore e atenda seus clientes nas redes sociais. Obtenha insights para tomar decisões de marketing e
            negócios cadastrando-se agora!
          </p>
          <Link to={{ pathname: '/signup' }}>
            <Button id="botao-cadastre-se" theme="white" className={style.button} xl>
              cadastre-se
            </Button>
          </Link>
        </div>
        <div className={style.line} />
        <Man className={style.man} />
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/Login.js